import axios from "axios";
import { Crypter } from "../Security/Crypter";
import Data from '../../Data/Data.json';
import SweetAlert from "sweetalert2";
import { NavigateFunction } from "react-router-dom";

export default function VerifDay(CodeU: string, CodeAge: string, authHeader: any, navigate: NavigateFunction) {

    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: Data.ApiUrl.VerifDay,
      headers: {
        'CypherCodu': Crypter.encrypt(CodeU),
        'CypherAgence': Crypter.encrypt(CodeAge),
        'Authorization': authHeader(),
        'Content-Type': 'application/json'
      }
    };
  
    axios.request(config)
      .then((response) => {
        if (response.data) {
          const res = JSON.parse(Crypter.decrypt(response.data)).Value;

          if (res.StatutCode == 200) {
            if (res.Result !== '50') {
              SweetAlert.fire({ title: "Warning", text: "impossible cas La journée comptable de l'agence est fermée", icon: "warning" });
  
              navigate("/");
            }
          }
          else SweetAlert.fire({ title: "Warning", text: res.Result, icon: "warning" })
        }
      })
      .catch((error) => {
        console.log(error)
      });
  }